import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import * as styles from './styles.css';
export { styles as dividerStyles };
import { cx } from '@paypalcorp/pp-react-utils';

var _excluded = ["className"];
var Divider = function (_ref) {
  var className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("hr", _extends({
    className: cx(styles.base, className)
  }, rest, {
    "data-ppui-info": "divider_5.1.2__8.12.0"
  }));
};

export { Divider };
